/** Registro dos jogos suportados, indexado pelo `game_type` do banco. */
import { checkers } from './checkers.ts';
import { chess } from './chess.ts';
import { ticTacToe } from './ticTacToe.ts';
import type { GameRules } from './types.ts';

export type GameType = 'CHESS' | 'CHECKERS' | 'TIC_TAC_TOE';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- cada jogo tem
// o proprio tipo de estado; o registro e intencionalmente heterogeneo.
const REGISTRY: Record<GameType, GameRules<any>> = {
  CHESS: chess,
  CHECKERS: checkers,
  TIC_TAC_TOE: ticTacToe,
};

export function rulesFor(gameType: string): GameRules<unknown> {
  const rules = REGISTRY[gameType as GameType];
  if (!rules) throw new Error(`GAME_TYPE_DESCONHECIDO: ${gameType}`);
  return rules;
}

export { checkers, chess, ticTacToe };
export * from './types.ts';
